import ScrollableRow from './ScrollableRow';

export default ScrollableRow;
